import { resolveIssuer } from './documentIssuer';

/**
 * Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼ â ÑÐµ Ð¶Ðµ Ð¿Ð¾Ð»Ñ, ÑÑÐ¾ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ñ Ð² ÑÐ¾ÑÐ¼Ðµ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸
 * (ÑÐ¸Ð¿, Ð½Ð¾Ð¼ÐµÑ, ÐºÐµÐ¼ Ð²ÑÐ´Ð°Ð½, Ð´Ð°ÑÑ Ð²ÑÐ´Ð°ÑÐ¸ Ð¸ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ñ). Ð¢Ð¾Ð³Ð´Ð° ÑÐ¾ÑÐ¼Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð½ÐµÐ·Ð°ÑÐµÐ¼.
 */
export const isDocumentComplete = (client) => {
  const doc = client?.document;
  if (!doc) return false;
  return Boolean(
    doc.document_type_id &&
      String(doc.document_number || '').trim() &&
      resolveIssuer(doc.document_issuer) &&
      doc.document_date &&
      doc.document_date_end
  );
};
